import { Grid, Tooltip, Zoom } from '@material-ui/core';
import React from 'react';
import { ExtendedRuleDefinition, FactDefinition } from '../../gen/api/api';
import useFieldHelpers from '../../helpers/fieldHelper';
import { getFactDisplayConfig } from '../../shared/settings/config';
import FieldFactory from '../ConfigurationForm/FieldFactory';

const { generateFieldName } = useFieldHelpers();

const useRuleComponents = () => {
    const renderFields = (
        ruleDefinition: ExtendedRuleDefinition,
        factDefinitions: FactDefinition[],
        factNamePrefix = '',
        disabled = false,
    ) => {
        if (!factDefinitions) {
            return;
        }

        return factDefinitions
            .map((factDefinition) => [
                factDefinition,
                getFactDisplayConfig(
                    ruleDefinition.ruleCode.concat('.', factDefinition.factCode),
                    factDefinition.factType,
                ),
            ])
            .sort(([_factDef1, factConf1], [_factDef2, factConf2]) => factConf1.order - factConf2.order)
            .map(([factDefinition, config]) => {
                const fieldName = generateFieldName(ruleDefinition, factDefinition);
                const fieldNameWithPrefix = generateFieldName(ruleDefinition, factDefinition, factNamePrefix);

                return (
                    <Grid item xs={config.width} key={factDefinition.factCode}>
                        <Tooltip
                            title={factDefinition.factDescription}
                            id={'tooltip-'.concat(fieldNameWithPrefix)}
                            key={'tooltip-'.concat(fieldName)}
                            arrow
                            placement="top"
                            TransitionComponent={Zoom}
                            disableHoverListener
                        >
                            <div>
                                <FieldFactory
                                    id={fieldNameWithPrefix}
                                    key={fieldNameWithPrefix}
                                    name={fieldName}
                                    ruleDefinition={ruleDefinition}
                                    factDefinition={factDefinition}
                                    disabled={disabled}
                                />
                            </div>
                        </Tooltip>
                    </Grid>
                );
            });
    };

    return {
        renderFields,
    };
};

export default useRuleComponents;
